import { createSlice } from "@reduxjs/toolkit";

const persistentSlice = createSlice({
    name: "perisitent",
    initialState: {
        is_switch_active: false,
        user_permissions: {},
        group_permissions: {},
        role_permissions: {},
        announcement_permissions: {},
        currentActive: "",
        voiceId: [],
        messages: [],
        botLoginQue: "",
        RON: "product",
        roleDropdown: { name: 'Sales Executive' },
        toneDropdown: { name: 'Casual' },
        styleDropdown: { name: 'Concise' },
        lengthDropdown: { name: 'Short' },
        complexityDropdown: { name: 'Simple' },
        keywords: "",
        key_features: "",
        product_name: "",
        purpose: "",
        topic: "",
        constraintsDropdown: { name: "Budget" },
        ageRangeDropdown: { name: "15-20" },
        objectiveDropdown: { name: "Marketing" },
        platformDropdown: { name: "Twitter" },
        channelDropdown: { name: "Online store" },
        desiredOutcomeDropDown: { name: 1 },
        handlerState: "",
        suggestionList: [],
        isUserHandler: false,
    },
    reducers: {
        handleIsUserHandler(state, action) {
            state.isUserHandler = action.payload
        },
        setSuggestionList(state, action) {
            state.suggestionList = action.payload
        },
        controlHandlerState(state, action) {
            state.handlerState = action.payload
        },
        handleConstraints(state, action) {
            state.constraintsDropdown = action.payload
        },
        handleDesiredOutcome(state, action) {
            state.desiredOutcomeDropDown = action.payload
        },
        handlePurpose(state, action) {
            state.purpose = action.payload
        },
        handleTopic(state, action) {
            state.topic = action.payload
        },
        handleChannel(state, action) {
            state.channelDropdown = action.payload
        },
        handlePlatform(state, action) {
            state.platformDropdown = action.payload
        },
        handleObjective(state, action) {
            state.objectiveDropdown = action.payload
        },
        handleAgeRange(state, action) {
            state.ageRangeDropdown = action.payload
        },
        handleKeywords(state, action) {
            state.keywords = action.payload
        },
        handleProductName(state, action) {
            state.product_name = action.payload
        },
        handleKeyFeatures(state, action) {
            state.key_features = action.payload
        },
        handleRON(state, action) {
            state.RON = action.payload
        },
        handleRole(state, action) {
            state.roleDropdown = action.payload
        },
        handleTone(state, action) {
            state.toneDropdown = action.payload
        },
        handleStyle(state, action) {
            state.styleDropdown = action.payload
        },
        handleLength(state, action) {
            state.lengthDropdown = action.payload
        },
        handleComplexity(state, action) {
            state.complexityDropdown = action.payload
        },
        handleBotLoginQue(state, action) {
            state.botLoginQue = action.payload
        },
        handleVoiceIds(state, action) {
            state.voiceId = action.payload
        },
        handleActive(state, action) {
            state.currentActive = action.payload
        },
        handleSwitch(state, action) {
            state.is_switch_active = action.payload
        },
        handleUserPermission(state, action) {
            state.user_permissions = action.payload
        },
        handleGroupPermission(state, action) {
            state.group_permissions = action.payload
        },
        handleRolePermission(state, action) {
            state.role_permissions = action.payload
        },
        handleAnnouncementPermission(state, action) {
            state.announcement_permissions = action.payload
        },
        addQuestion: (state: any, action) => {
            state.messages.push(action.payload)
        },
        updateQuestion: (state: any, action) => {
            const updatedMessage = action.payload;
            const index = state.messages.findIndex((message: { id: any; }) => message.id === updatedMessage.id);
            if (index !== -1) {
                state.messages[index] = updatedMessage;
            }
        },
        resetQuestion: (state) => {
            state.messages = []
        },
    }
})

export const { handleIsUserHandler, setSuggestionList, controlHandlerState, addQuestion, updateQuestion, resetQuestion, handleConstraints, handleDesiredOutcome, handleTopic, handlePurpose, handleProductName, handleKeyFeatures, handleChannel, handlePlatform, handleObjective, handleAgeRange, handleComplexity, handleKeywords, handleLength, handleStyle, handleTone, handleRole, handleRON, handleBotLoginQue, handleVoiceIds, handleActive, handleSwitch, handleUserPermission, handleGroupPermission, handleRolePermission, handleAnnouncementPermission } = persistentSlice.actions;

export default persistentSlice.reducer;